import React, { Dispatch, SetStateAction } from 'react'
import { NoteDraft } from './NoteTextEditor.types'

type NoteEditorTopBarProps = {
  data: NoteDraft
  setData: Dispatch<SetStateAction<NoteDraft>>
  viewOnly: boolean
  isEditingTitle: boolean
  setIsEditingTitle: Dispatch<SetStateAction<boolean>>
  rightTopEditorButtons?: () => React.ReactNode
}

const NoteEditorTopBar: React.FC<NoteEditorTopBarProps> = ({
  data,
  setData,
  viewOnly,
  isEditingTitle,
  setIsEditingTitle,
  rightTopEditorButtons,
}) => (
  <div className="note-top-toolbar">
    {isEditingTitle ? (
      <input
        type="text"
        value={data.title}
        onChange={(e) =>
          setData((prev) => ({ ...prev, title: e.target.value }))
        }
        onBlur={() => setIsEditingTitle(false)}
        className="note-title-input"
        autoFocus
      />
    ) : (
      <span
        className="note-title"
        {...(viewOnly && { style: { cursor: 'default' } })}
        {...(!viewOnly && { onClick: () => setIsEditingTitle(true) })}
      >
        {data.title}
      </span>
    )}
    {!viewOnly && (
      <i
        className="mgc mgc_pencil_fill"
        onClick={() => setIsEditingTitle(true)}
        style={{ marginLeft: '0px', cursor: 'pointer' }}
      />
    )}
    {rightTopEditorButtons?.()}
  </div>
)

export default NoteEditorTopBar
